import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { downloadPdf } from "../../../lib/downloadPdf";

export default function ClassSelectionModal({ isOpen, month, onClose }) {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setSelectedClass(null);
    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/getClassByStatus`)
      .then((response) => {
        if (response.data.success) {
          setClasses(
            response.data.data.map((c) => ({
              value: c.class_id,
              label: c.class_name,
            }))
          );
        } else {
          console.error("Failed to fetch classes:", response.data.message);
          alert("Failed to load classes.");
          setClasses([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching classes:", err);
        alert("Error loading classes.");
        setClasses([]);
      });
  }, [isOpen]);

  if (!isOpen) return null;

  const handlePrint = async () => {
    if (!selectedClass) {
      alert("Please select a class.");
      return;
    }
    if (!month) return;

    const url = `${process.env.REACT_APP_API_URL}/admin/pdf/byclass?month=${month}&class_id=${selectedClass.value}`;
    try {
      await downloadPdf(url, `class_${selectedClass.label}_${month}.pdf`);
      onClose();
    } catch (err) {
      console.error("Error downloading PDF by class:", err);
      alert("Error generating PDF.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[60]">
      <div className="bg-white p-6 rounded-lg w-1/2">
        <h3 className="text-xl font-semibold mb-4">Print Invoices by Class</h3>
        <div className="mb-6">
          <label className="block text-gray-700 mb-1">Select Class:</label>
          <Select
            options={classes}
            value={selectedClass}
            onChange={setSelectedClass}
            placeholder="Choose a class..."
            isClearable
            className="w-full"
            classNamePrefix="react-select"
          />
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => {
              setSelectedClass(null);
              onClose();
            }}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={handlePrint}
            className="bg-indigo-500 text-white px-4 py-2 rounded hover:bg-indigo-600"
          >
            Print
          </button>
        </div>
      </div>
    </div>
  );
}
